export default "__VITE_ASSET__DBc_sHYQ__"